import { User as InternalUser } from 'data/User'
import { Environment } from 'data/Environment'
import { User as Auth0User } from '@auth0/auth0-react'

/**
 * Converts and Auth0 user to an internal User for our app
 *
 * @param {Auth0User} user
 * @param {Environment} environment - The app environment config
 * @returns {InternalUser} - The translated user
 */
export const translateAuth0User = (auth0User: Auth0User, environment: Environment): InternalUser => {
    const { claimNamespace: CLAIM_NAMESPACE } = environment.auth0 as Environment

    const countryName = auth0User[`${CLAIM_NAMESPACE}/country`]
    const country = { emoji: '--', name: countryName || '', code: '--' }

    const region = auth0User[`${CLAIM_NAMESPACE}/region`]
    const city = auth0User[`${CLAIM_NAMESPACE}/city`]

    return {
        _id: auth0User[`${CLAIM_NAMESPACE}/userId`],
        email: auth0User[`${CLAIM_NAMESPACE}/email`],
        displayName: auth0User[`${CLAIM_NAMESPACE}/displayName`],
        location: country && region && city ? `${city}, ${region}, ${country.name}` : '',
        birthDate: auth0User[`${CLAIM_NAMESPACE}/birthDate`],
        chatColor: auth0User[`${CLAIM_NAMESPACE}/chatColor`],
        country,
        region,
        city,
    }
}
